import React, { memo } from 'react';
import DeliveryBadge from '../../../ad/components/DeliveryBadge';
import S from './style/AdImage';

function AdImage({ src, loading = false }) {
  return (
    <S.BlockImage data-testid="ad-image">
      <S.BlockImageBadge isLoading={loading}>
        <DeliveryBadge large={false} />
      </S.BlockImageBadge>
      {src === null ? (
        <S.BlockImageContainer image={src}>
          <S.PhotoPlaceholder />
        </S.BlockImageContainer>
      ) : (
        <S.BlockImageContainer>
          <S.CenteredImage src={src} />
        </S.BlockImageContainer>
      )}
    </S.BlockImage>
  );
}

export default memo(AdImage);
